import { Pane, Strong, Text } from "evergreen-ui";
import React from "react";
import { formatNumberAsCurrency } from "../../util";

function StatsCard(props) {

  const onlineBookings = formatNumberAsCurrency(props.currency, props.statsObject.online);
  const offlineBookings = formatNumberAsCurrency(props.currency, props.statsObject.offline);
  const totalBookings = formatNumberAsCurrency(props.currency, props.statsObject.online + props.statsObject.offline);

  return (
    <Pane
      display="flex"
      flexDirection="column"
      alignItems="start"
      background="white"
      width={"100%"}
      borderRadius={"10px"}
      padding="20px"
    >
      <Strong size={500} fontSize="20px" lineHeight="42px" fontWeight="700" color="#0f4d88">
        { totalBookings }
      </Strong>
      <Text color="gray600" textTransform="capitalize">
        {props.title} (GTV)
      </Text>
      <Pane
        display="flex"
        flexDirection="row"
        alignItems="center"
        width="100%"
        justifyContent="space-between"
        marginTop="16px"
      >
        <Text>Online</Text>
        <Strong>{ onlineBookings }</Strong>
      </Pane>
      <Pane
        display="flex"
        flexDirection="row"
        alignItems="center"
        width="100%"
        justifyContent="space-between"
        marginTop="16px"
      >
        <Text>Offline</Text>
        <Strong>{ offlineBookings }</Strong>
      </Pane>
    </Pane>
  );
}

export default StatsCard;
